
import i18n from '@/commons/translations/i18n'
import { Component, Prop, Vue } from 'vue-property-decorator'
import ModalBox from '@/commons/components/modal-box/ModalBox.vue'
import ModalBoxPhotoPreliminaryCheckContent
    from '@/commons/components/modal-box/ModalBoxPhotoPreliminaryCheckContent.vue'

@Component({
    components: {
        ModalBox
    }
})
export default class ModalBoxPhotoPreliminaryCheck extends Vue {
    @Prop() errors!: Array<string>
    @Prop() uploadCallback!: () => void

    modalBoxBodyInstance (): Vue {
        return new ModalBoxPhotoPreliminaryCheckContent(
            {
                name: 'PreliminaryCheckResults',
                i18n: i18n,
                propsData: {
                    errorsCallback: () => this.errors,
                    uploadCallback: this.uploadCallback
                }
            })
    }
}
